import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@sib/api';
import { I18nextProvider } from '@sib/i18n';
import { i18n } from '@sib/i18n';
import { NotificationProvider } from '@sib/notifications';
import { TooltipProvider } from '@sib/ui';
import '@sib/ui/styles';
import Routes from './App.routes';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider>
        <BrowserRouter>
          <TooltipProvider
            delayDuration={0}
            skipDelayDuration={0}
            disableHoverableContent={true}
          >
            <NotificationProvider>
              <Routes />
            </NotificationProvider>
          </TooltipProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </I18nextProvider>
  );
}

export default App;
